import type { IPContext } from "@outschool/iplookup-client";
import { useLookupIP } from "@outschool/iplookup-client";

import pkg from "../../lib/pkg";

export default function useIpLocation(): IPContext {
  const ipContext = useLookupIP();

  if (!pkg.devMode) {
    return ipContext;
  }

  const context: IPContext = {
    ipInfo: null,
    ipInfoLoaded: false,
    isInCA: pkg.devMode === "ca",
    isInEurozone: pkg.devMode === "eurozone",
    isInGDPR: pkg.devMode === "gdpr",
    isInUSA: false,
    isInWaNv: false,
  };

  if (pkg.devMode === "timeout") {
    return context;
  }

  context.ipInfoLoaded = true;

  return context;
}
